export default __webpack_public_path__ + "static/media/luminr-logo-black.9a586a04.svg";